/**
 * Awesome Oscillator (AO)
 *
 * Bill Williams' momentum indicator. Difference between 5-period
 * and 34-period SMA of the midpoint price (H+L)/2.
 * Displayed as a histogram colored based on rising/falling.
 *
 * Category: Momentum | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const awesomeOscillatorIndicator: IndicatorDefinition = {
  id: "ao",
  name: "Awesome Oscillator",
  shortName: "AO",
  category: "momentum",
  pane: "separate",
  params: [
    { key: "fast", label: "Fast Period", type: "number", default: 5, min: 2, max: 50 },
    { key: "slow", label: "Slow Period", type: "number", default: 34, min: 5, max: 200 },
  ],
  plots: [
    { key: "ao", label: "AO", color: "#4CAF50", style: "histogram", lineWidth: 1, priceScaleId: "ao", histogramBase: 0 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { fast, slow } = params;
    const hl2 = candles.map(c => (c.high + c.low) / 2);
    const data: { time: number; value: number; color?: string }[] = [];

    for (let i = slow - 1; i < hl2.length; i++) {
      let fastSum = 0, slowSum = 0;
      for (let j = i - fast + 1; j <= i; j++) fastSum += hl2[j];
      for (let j = i - slow + 1; j <= i; j++) slowSum += hl2[j];
      const val = fastSum / fast - slowSum / slow;
      const prevVal = data.length > 0 ? data[data.length - 1].value : 0;
      data.push({
        time: candles[i].time,
        value: val,
        color: val >= prevVal ? "#4CAF50" : "#F44336",
      });
    }

    return [{ key: "ao", data }];
  },
};
